var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('svg',{staticClass:"logo",attrs:{"width":"25%","height":"100px"}},[_c('text',{staticClass:"animate",attrs:{"x":"0","y":"20","fill":"none"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.name))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/share/Header.vue?vue&type=template&id=47ee462e&scoped=true&
// module id = null
// module chunks = 